export default class AutoSuggestModel {
    // Handles array of suggestions
    suggestionsHandler: (any) => (any)

    // Whatever is currently selected by suggestionClickHandler
    selection: any

    // Executes on suggestion click
    suggestionClickHandler: (any) => (any)

    // Dependency for updating useEffect via updateContextHandler
    updateContext: (any) => (any)

    // Executes on updateContext update
    updateContextHandler: () => (any)

    // Function that executes on pressing escape or deleting input fully
    clearHandler: () => (any)

    // Handles additional string input processing, such as formatting
    inputHandler: (any) => (any)

    // Should the decoration component display
    decorationDisplayHandler: (any) => (any)

    // SuggestionsHandler input min limit
    suggestionLengthFetchLimit: number

    // Focuses on ref based on conditions provided
    focusHandler: (any) => (any)

    constructor(params) {
        const {
            suggestionsHandler,
            selection,
            suggestionClickHandler,
            updateContext,
            updateContextHandler,
            clearHandler,
            inputHandler,
            decorationDisplayHandler,
            suggestionLengthFetchLimit,
            focusHandler,
        } = params

        this.suggestionsHandler = suggestionsHandler
        this.selection = selection
        this.suggestionClickHandler = suggestionClickHandler
        this.updateContext = updateContext
        this.updateContextHandler = updateContextHandler
        this.clearHandler = clearHandler
        this.inputHandler = inputHandler
        this.decorationDisplayHandler = decorationDisplayHandler
        this.suggestionLengthFetchLimit = suggestionLengthFetchLimit
        this.focusHandler = focusHandler
    }
}